"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const dialog_1 = require("primereact/dialog");
const CustomModal = ({ visible, onHide, title, children, closable = true, className, contentClassName, }) => {
    return ((0, jsx_runtime_1.jsx)(dialog_1.Dialog, { visible: visible, onHide: onHide, header: title, className: `${className} w-11/12 sm:w-2/3 md:w-1/2 lg:w-1/3 montserratMedium`, draggable: false, dismissableMask: true, closable: closable, showHeader: !!title, contentClassName: contentClassName, children: (0, jsx_runtime_1.jsx)("div", { className: "p-4", children: children }) }));
};
exports.CustomModal = CustomModal;
